import classes from "./select.module.css";
import { useState } from "react";
import icon from "./../icons/dropdownIcon.svg";

export interface IItemList {
  label: string;
  value: string | null;
}

interface IProps {
  label?: string;
  value: string | null;
  list: IItemList[];
  onChange: (value: string | null) => void;
}

const Select = ({ label, list, value, onChange }: IProps) => {
  const [isOpen, setOpen] = useState(false);

  const currentItem = list.find((item) => {
    return item.value === value;
  });

  const handleToggle = () => {
    setOpen(prev => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (item: IItemList) => {
    onChange(item.value);
  };

  const options = list.map(item => {
    const classNames = [classes.dropdownItem];

    if (item.value === value) {
      classNames.push(classes.isActive);
    }

    return (
      <li
        className={classNames.join(" ")}
        key={item.value}
        onClick={() => handleChange(item)}
      >
        {item.label}
      </li>
    );
  });

  return (
    <div className={classes.wrapper} onMouseLeave={handleClose}>
      { label && <label className={classes.label}>{ label }</label> }
      <div
        className={`${classes.select} ${isOpen ? classes.isOpen : null}`}
        onClick={handleToggle}
      >
        <div className={classes.selected}>
          <span className={classes.selectedLabel}>{currentItem ? currentItem.label : ""}</span>
        </div>

        <ul className={classes.dropdown}>
          { options }
        </ul>

        <div className={classes.arrow}>
          <img src={icon} width="8" height="5" alt=""/>
        </div>
      </div>
    </div>
  );
};

export default Select;
